module.exports = ".banner-box {\r\n  display: table;\r\n  width: 100%;\r\n  position: absolute;\r\n  top: 0;\r\n  height:100%;\r\n  background-color: rgb(33, 82, 125);\r\n  color: white;\r\n}\r\n\r\n.banner-box-cell {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fsapplication/faceted-search-app-banner/faceted-search-app-banner.component.css
// module id = ./src/app/fsapplication/faceted-search-app-banner/faceted-search-app-banner.component.css
// module chunks = main